function isMobileByUA() {
  const ua = navigator.userAgent;
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua);
}

function isMobileByScreen() {
  return window.innerWidth < 768;
}

function isMobileByTouch() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

function isMobile() {
  return isMobileByUA() || (isMobileByScreen() && isMobileByTouch());
}


export default {
  data(){
    return{
      isMobile:isMobile()
    }
  },
}